import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { MdDescription, MdSettings } from 'react-icons/md'
import { BiUser } from 'react-icons/bi'

export default function RightNav(): React.ReactElement {
    const { logout } = useContext(AuthContext) as AuthContextType
    const navigate = useNavigate()

    return (
        <div className="rightNav">
            <div className="wrapper-links">
                <Link to={'/'} className="drop-link">
                    <MdDescription />
                    Arquivos
                </Link>
                <Link to={'/maintenances'} className="drop-link">
                    <MdSettings />
                    Manutenções
                </Link>
                <Link to={'/profile'} className="drop-link">
                    <BiUser />
                    Perfil
                </Link>
                <button
                    className="button-primary"
                    onClick={() => {
                        logout()
                        navigate('/login')
                    }}
                >
                    Sair
                </button>
            </div>
        </div>
    )
}
